<template>
  <div>
    <div class="cardList" v-if="cardList.length>0" v-for="(item,index) in cardList" :key="index">
      <HealthCard :id-card="item.idCard" :name="item.clinic_patient_name" :qrcodeUrl="item.QrTextCodeImgUrl" :healthCardId="item.healthCardId" @toDetails="toDetails(item)" @addCard="addCard(item)"></HealthCard>
    </div>
    <div class="noCard" v-if="!cardList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无数据</div>
    </div>
    <div class="button">
      <div class="addBtn" @click="addCard">+ 添加健康卡</div>
    </div>
    <div style="text-align: center;font-size: .28rem;color: #409eff;height: .6rem;line-height: .6rem;margin-top: .4rem;margin-bottom: .6rem;" @click="yjsq">
      《已有健康卡，一键授权》
    </div>
  </div>
</template>

<script>
  import HealthCard from '../common/HealthCard'
  import {getCardList} from '../../api/index'
  import storage from "../../utils/storage";
    export default {
      data(){
        return{
          cardList:[],
        }
      },
      components:{
        HealthCard
      },
      created() {
        //修改标题
        document.title = '电子健康卡管理'
        this.getCardList()
      },
      methods:{
        getCardList(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getCardList({
            open_id:this.$storage.get('openid'),
            unionid:this.$storage.get('unionid')
          }).then(res=>{
            loading.close();
            this.cardList = res.Data
            if(res.Data.length>0){
              this.$storage.set('patient',res.Data[0])//默认就诊人
              this.$storage.set('patients',res.Data)//所有就诊人
            }
          })
        },
        addCard(item){
          if(item.clinic_patient_name){
            this.$storage.set('clinic_patient_name',item.clinic_patient_name)
            this.$storage.set('clinic_num',item.clinic_num)
            this.$router.push({path:'/addHealthCard'})
          }else {
            this.$storage.remove('clinic_patient_name')
            this.$storage.remove('clinic_num')
            this.$router.push({path:'/addHealthCard'})
          }
        },
        toDetails(item){
          this.$router.push({path:'/healthCardDetails',query:{id:item.id}})
        },
        yjsq(){
          this.$storage.remove('clinic_patient_name')
          this.$storage.remove('clinic_num')
          window.location.href = 'https://health.tengmed.com/open/getHealthCardList?redirect_uri='+encodeURIComponent(location.protocol + '//' + location.host +'/#/addHealthCard')
        },
      }
    }
</script>

<style scoped>
  .cardList {
    width: 7.5rem;
    padding: .3rem 0 0 0;
    background: #fff;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: .3rem 0 0 0;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
  .button {
    margin: .68rem 0 .2rem 0;
  }
  .button .addBtn {
    display: block;
    background: #409EFF;
    border-radius: .1rem;
    width: 6.9rem;
    height: .94rem;
    line-height: .94rem;
    font-size: .36rem;
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/personManage.vue